import api from './api';
import { ApiResponse, PageResponse, QuestionBank, QuestionBankRequest, BankQuestion, QuestionRequest } from '../types';

export const questionBankService = {
  // ========== 题库 CRUD ==========

  getBanks: async (keyword?: string, page: number = 0, size: number = 20): Promise<PageResponse<QuestionBank>> => {
    const params: any = { page, size };
    if (keyword) params.keyword = keyword;
    const response = await api.get<ApiResponse<PageResponse<QuestionBank>>>('/admin/question-banks', { params });
    return response.data.data;
  },

  getAllBanks: async (): Promise<QuestionBank[]> => {
    const response = await api.get<ApiResponse<QuestionBank[]>>('/admin/question-banks/all');
    return response.data.data;
  },

  getBank: async (bankId: number): Promise<QuestionBank> => {
    const response = await api.get<ApiResponse<QuestionBank>>(`/admin/question-banks/${bankId}`);
    return response.data.data;
  },

  createBank: async (request: QuestionBankRequest): Promise<QuestionBank> => {
    const response = await api.post<ApiResponse<QuestionBank>>('/admin/question-banks', request);
    return response.data.data;
  },

  updateBank: async (bankId: number, request: QuestionBankRequest): Promise<QuestionBank> => {
    const response = await api.put<ApiResponse<QuestionBank>>(`/admin/question-banks/${bankId}`, request);
    return response.data.data;
  },

  deleteBank: async (bankId: number): Promise<void> => {
    await api.delete(`/admin/question-banks/${bankId}`);
  },

  // ========== 题库题目 CRUD ==========

  getBankQuestions: async (bankId: number): Promise<BankQuestion[]> => {
    const response = await api.get<ApiResponse<BankQuestion[]>>(`/admin/question-banks/${bankId}/questions`);
    return response.data.data;
  },

  getBankQuestion: async (bankId: number, questionId: number): Promise<BankQuestion> => {
    const response = await api.get<ApiResponse<BankQuestion>>(`/admin/question-banks/${bankId}/questions/${questionId}`);
    return response.data.data;
  },

  createBankQuestion: async (bankId: number, request: QuestionRequest): Promise<BankQuestion> => {
    const response = await api.post<ApiResponse<BankQuestion>>(`/admin/question-banks/${bankId}/questions`, request);
    return response.data.data;
  },

  updateBankQuestion: async (bankId: number, questionId: number, request: QuestionRequest): Promise<BankQuestion> => {
    const response = await api.put<ApiResponse<BankQuestion>>(`/admin/question-banks/${bankId}/questions/${questionId}`, request);
    return response.data.data;
  },

  deleteBankQuestion: async (bankId: number, questionId: number): Promise<void> => {
    await api.delete(`/admin/question-banks/${bankId}/questions/${questionId}`);
  },

  // ========== 存入题库 / 从题库导入 ==========

  saveQuestionToBank: async (questionnaireId: number, questionId: number, questionBankId: number): Promise<void> => {
    await api.post(`/admin/questionnaires/${questionnaireId}/questions/${questionId}/save-to-bank`, { questionBankId });
  },

  importFromBank: async (questionnaireId: number, bankQuestionIds: number[]): Promise<number[]> => {
    const response = await api.post<ApiResponse<number[]>>(
      `/admin/questionnaires/${questionnaireId}/questions/import-from-bank`,
      { bankQuestionIds }
    );
    return response.data.data;
  },
};
